import type { HTMLAttributes, ReactNode } from 'react';
import { classNames } from '~/utils/styles';

export type HeaderProps = {
    children: ReactNode;
    className?: string;
    separated?: boolean;
    padded?: boolean;
} & HTMLAttributes<HTMLElement>;

/** @deprecated Use PageHeader/FormLayout instead */
export default function Header({
    children,
    className = '',
    separated = false,
    padded = false,
    ...props
}: HeaderProps) {
    return (
        <header
            className={classNames({
                'page-header': true,
                'page-header-separated': separated,
                'page-header-padded': padded,
                [className]: Boolean(className),
            })}
            {...props}>
            {children}
        </header>
    );
}

export type HeaderTitleProps = {
    children: ReactNode;
} & HTMLAttributes<HTMLHeadingElement>;

const HeaderTitle = ({ children, ...props }: HeaderTitleProps) => <h1 {...props}>{children}</h1>;

export type HeaderActionsProps = {
    children?: ReactNode;
    className?: string;
} & HTMLAttributes<HTMLDivElement>;

const HeaderActions = ({ children, className = '', ...props }: HeaderActionsProps) => (
    <div
        className={classNames({ 'page-header-actions': true, [className]: Boolean(className) })}
        {...props}>
        {children}
    </div>
);

export type HeaderActionsBlockProps = {
    children: ReactNode;
} & HTMLAttributes<HTMLDivElement>;

HeaderActions.Block = ({ children, ...props }: HeaderActionsBlockProps) => (
    <div
        className='page-header-actions-block'
        {...props}>
        {children}
    </div>
);

HeaderActions.Separator = () => <span className='page-header-actions-separator'></span>;

export type HeaderLegendProps = {
    children: ReactNode;
} & HTMLAttributes<HTMLDivElement>;

function HeaderLegend({ children, ...props }: HeaderLegendProps) {
    return (
        <div
            {...props}
            className='page-header-legend'>
            {children}
        </div>
    );
}

function MetadataRow({
    children,
    className = '',
}: { children: ReactNode; className?: string } & HTMLAttributes<HTMLDivElement>) {
    return (
        <div
            className={classNames({
                'flex flex-wrap gap-x-4 gap-y-2 justify-start hide-empty': true,
                [className]: Boolean(className),
            })}>
            {children}
        </div>
    );
}
function Metadata({
    children,
    className = '',
}: { children: ReactNode; className?: string } & HTMLAttributes<HTMLDivElement>) {
    return (
        <div
            className={classNames({
                'flex flex-wrap gap-6 justify-start hide-empty': true,
                [className]: Boolean(className),
            })}>
            {children}
        </div>
    );
}

/** @deprecated Use PageHeader instead */
Header.Title = HeaderTitle;
/** @deprecated Use PageHeader instead */
Header.Actions = HeaderActions;
/** @deprecated Use PageHeader instead */
Header.Legend = HeaderLegend;
/** @deprecated Use PageHeader instead */
Header.Metadata = Metadata;
/** @deprecated Use PageHeader MetadataRow */
Header.MetadataRow = MetadataRow;
